import React from "react";
import { Navbar, NavbarBrand } from "reactstrap";

export const AppNavbar = () => {
  return (
    <div>
      <Navbar
        light
        expand="lg"
        style={{
          backgroundColor: "#fff",
          borderColor: "#fff",
          paddingLeft: "15px",
        }}
      >
        <NavbarBrand href="#" style={{ color: "#4941A7" }}>
          Price Tool
        </NavbarBrand>
      </Navbar>
    </div>
  );
};
